$(document).on('turbolinks:load', function() {
  $('.manage-children').on('click', '#add-child-modal-trigger', function(e) {
    e.preventDefault();
    $('#add_child_modal').addClass('visible');
  });

  $('#add_child_modal').on('submit', 'form', function(e) {
    let year = parseInt($('.date-entry-fields input.year').val()),
        month = parseInt($('.date-entry-fields input.month').val()) - 1,
        day = parseInt($('.date-entry-fields input.day').val()),
        birthday = new Date(year, month, day);
    let seconds = Math.floor((new Date() - birthday) / 1000),
        years = seconds / 31536000;
    if (years < 13) {
      e.preventDefault();
      $('#add_child_warn_modal').addClass('visible');
      setTimeout(function() {
        $('#add_child_modal form input[type="submit"]').prop('disabled', false);
      }, 150);
    }
  });

  if($('.account-select').length>0) {
    $('.account-select ul.mdc-list li').on('click', function() {
      window.location.href = '/impersonate/student/' + $(this).data('value') + '?name=child';
    });

    $('.account-select').on('click', function() {
      if ($('#parent-impersonate').val() == "true" ) {
        $('.account-select ul.mdc-list').parent().attr('id', 'enable-scroll');
      }
    });
  }
})
